import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemDominiosExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => {
      return {
        id: item.id,
        status: optionStatusBin[item.status]?.label,
        nome: item.nome,
        descricao: item.descricao,
        filhos: item.filhos,
        observacoes: item.observacoes,
        usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
        nEdicoes: item.nEdicoes || 0,
      };
    });

    const mainSheet: ExportSheet = {
      name: 'Listagem de Domínios',
      columns: {
        id: 'ID',
        status: 'Status',
        nome: 'Nome',
        descricao: 'Descrição',
        filhos: 'Filhos',
        observacoes: 'Observações',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
